import GenerateDocument from "@/models/GenerateDocument";

const getDefaultState = () => ({
    filterData: undefined,
    filterByOptions: [],
});

export default {
    namespaced: true,
    
    state: getDefaultState(),

    getters: {
        getFilterBy(state) {
            return state.filterData;
        },

        getFilterByOptions(state) {
            return state.filterByOptions;
        }
    },

    mutations: {
        CLEAR(state) {
            Object.assign(state, getDefaultState());
        },
        
        SET_FILTER_BY(state, data) {
            state.filterData = data;
        },

        SET_FILTER_BY_OPTIONS(state, options) {
            state.filterByOptions = [];

            if(options.length > 0) {
                options.forEach(option => {
                    state.filterByOptions.push({companyProcessId: option.company_process_id, filter: option.filter});
                });
               
                if(state.filterByOptions.length > 0) {
                    // state.filterData = state.filterByOptions[state.filterByOptions.length - 1];

                    // eslint-disable-next-line prefer-destructuring
                    state.filterData = state.filterByOptions[0];
                }
                else state.filterData = undefined;
            }
        }
    },

    actions: {
        async SET_FILTER_OPTIONS({ commit }, process) {
            commit('SET_FILTER_BY_OPTIONS', await GenerateDocument.getFilterData(process));
        },

        CLEAR_FILTER({ commit }) {
            commit('CLEAR');
        },
    }
};
